import { lazy } from 'react';

// project import
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import ProductPage from 'pages/product-page';
import InstallTutorail from 'pages/install-tutorial';

// render - login
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgot-password')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/reset-password')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/code-verification')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <GuestGuard>
          <CommonLayout />
        </GuestGuard>
      ),
      children: [
        {
          path: '/',
          element: <AuthLogin />
        },
        {
          path: 'login',
          element: <AuthLogin />
        },

        {
          path: 'forgotPw',
          element: <AuthForgotPassword />
        },

        {
          path: 'resetPw',
          element: <AuthResetPassword />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        },
        {
          path: 'install_tutorial',
          element: <InstallTutorail />
        },
        {
          path: '*',
          element: <MaintenanceError />
        }
      ]
    }
  ]
};

export default LoginRoutes;
